export default {"src":"/_next/static/media/FacilitiesIconRed.0a59d9e9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};